import { TbAlertTriangle, TbFileText, TbPhone, TbRuler, TbUser, TbUsers } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const managementRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.MANAGEMENT,
        meta: {
            label: "management",
            order: 4,
            icon: TbRuler,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
        },
        children: [
            {
                to: APP_ROUTES_TO.MANAGEMENT_USERS,
                meta: {
                    label: "users",
                    order: 1,
                    icon: TbUser,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
                },
            },
            {
                to: APP_ROUTES_TO.MANAGEMENT_TEAMS,
                meta: {
                    label: "teams",
                    order: 2,
                    icon: TbUsers,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
                },
            },
            {
                to: APP_ROUTES_TO.MANAGEMENT_PHONE_NUMBERS,
                meta: {
                    label: "phone_numbers",
                    order: 3,
                    icon: TbPhone,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
                },
            },
            {
                to: APP_ROUTES_TO.INCIDENTS,
                meta: {
                    label: "incidents",
                    order: 4,
                    icon: TbAlertTriangle,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
                },
            },
            {
                to: APP_ROUTES_TO.MANAGEMENT_CUSTOM_PAGES,
                meta: {
                    label: "custom_pages",
                    order: 5,
                    icon: TbFileText,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
                },
            },
        ],
    },
];
